import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";
import { Hospedes } from "../interfaces/Hospedes";
import { formatDate } from "../utils/dateUtils";

// Função para buscar as reservas

export const hospedesService = async (reserva: number) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/hospedes/reserva/${reserva}`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      const hospedesArray = response.data.map((p: Hospedes) => {
        const formattedDate = formatDate(new Date(p.Usuario.dataNascimento));

        return {
          ...p,
          key: p.idReserva,
          dataReserva: formattedDate,
          idUsuario: p.idUsuario,
        };
      });

      return hospedesArray; // Agora retorna o array processado
    } catch (error) {
      console.log(error);
    }
  }
  return false; // Retorna um array vazio se o Token não for válido
};

export {};
